interface LikeIconProps {
  size?: number;
  color?: string;
  className?: string;
}

export default function LikeIcon({ 
  size = 14, 
  color = '#FFFFFF',
  className = '' 
}: LikeIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill={color}
      className={className}
    >
      <path
        d="M4.36161 10.9375C4.1137 10.9375 3.88328 10.8124 3.79286 10.5601C3.60619 10.0408 3.5 9.47689 3.5 8.86719C3.5 7.76903 3.84913 6.76163 4.43421 5.97309C4.52229 5.85289 4.65179 5.78049 4.78421 5.72762C5.05346 5.62338 5.29671 5.41552 5.48454 5.14637C5.8532 4.62914 6.30648 4.20005 6.825 3.87719C7.24675 3.62402 7.6125 3.26644 7.78925 2.79427C7.89688 2.50544 7.96979 2.09306 7.96979 1.71667V1.16667C7.96979 1.05616 8.01371 0.950179 8.09154 0.872314C8.16936 0.79449 8.27531 0.750001 8.38579 0.750001C8.79621 0.750001 9.18987 0.912993 9.48076 1.20349C9.77166 1.49399 9.93517 1.88731 9.93517 2.29719C9.93517 3.01594 9.78267 3.69636 9.51579 4.30636C9.35942 4.65436 9.5775 5.10586 9.93867 5.10586H11.7625C12.0467 5.10587 12.3217 5.21338 12.5374 5.40465C12.7531 5.59593 12.8952 5.85831 12.9372 6.14527C12.9635 6.40823 12.9768 6.67548 12.9768 6.94881C12.9769 8.62003 12.4311 10.2373 11.4309 11.5227C11.2043 11.823 10.8552 11.9767 10.4948 11.9767H8.4467C8.16492 11.9767 7.88433 11.9282 7.61779 11.8344L5.8013 11.1527C5.52833 11.0538 5.24405 11.0031 4.9627 11.0023H4.50781L4.36161 10.9375ZM0.776433 5.96575C0.612016 6.75648 0.291666 7.71448 0.291666 8.61394C0.291666 9.36798 0.393059 10.029 0.595016 10.6342C0.746683 11.1298 1.22735 11.4522 1.74594 11.4522H2.275C2.53458 11.4522 2.695 11.1417 2.58008 10.9083C2.30861 10.3395 2.16617 9.71936 2.16077 9.09027C2.16077 8.02644 2.4401 7.06231 2.92194 6.21175C3.06485 5.96002 2.90558 5.61398 2.63027 5.61398H1.89583C1.41052 5.61398 0.953683 5.89575 0.776016 6.37748L0.776433 5.96575Z"
      />
    </svg>
  );
}
